import COS from 'cos-js-sdk-v5';
import Config from '../constants/Config';
import { getAccessToken } from './access-token-storage';

// eslint-disable-next-line import/prefer-default-export
export function uploadFile(path, file, upLoadAdd = 'attachments') {
  const url = `${Config.SERVER_BASE_URL}/api/${upLoadAdd}/sts`; // url 替换成您自己的后端服务
  const cos = new COS({
    getAuthorization: (options, callback) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      const accessToken = getAccessToken();
      xhr.setRequestHeader('Authorization', `Bearer ${accessToken}`);
      // eslint-disable-next-line consistent-return
      xhr.onload = (e) => {
        let data;
        let credentials;
        try {
          data = JSON.parse(e.target.responseText);
          ({ credentials } = data);
          // eslint-disable-next-line no-empty
        } catch (error) {}
        if (!data || !credentials) {
          // eslint-disable-next-line no-console
          return console.error(`credentials invalid:\n${JSON.stringify(data, null, 2)}`);
        }
        callback({
          TmpSecretId: credentials.tmpSecretId,
          TmpSecretKey: credentials.tmpSecretKey,
          SecurityToken: credentials.sessionToken,
          // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
          StartTime: data.startTime,
          ExpiredTime: data.expiredTime, // 时间戳，单位秒，如：1580000000
        });
      };
      xhr.send(JSON.stringify(options.Scope));
    },
  });
  return cos.uploadFile({
    Bucket: Config.COS_BUCKET,
    Region: Config.COS_REGION,
    Key: `${path}/${file.name}`,
    Body: file,
  });
}
